module.exports = __webpack_public_path__ + "static/media/Archivo-Medium.cf46fbef.ttf";